import React from "react";

import { Container, Row, Col, Nav } from "react-bootstrap";

import youtube from "../../assets/youtube.svg";
import twitter from "../../assets/twitter.svg";
import linkedin from "../../assets/linkedin.svg";

import Parser from "html-react-parser";

import { useTranslation } from "react-i18next";

import classes from "./Footer.module.css";
import { isAdvanced, isContributor } from "../../shared/utility";
import { NavLink, useHistory } from "react-router-dom";

const Footer: React.FC = (props: any) => {
  const { t, i18n } = useTranslation();
  const isAdvancedUser = isAdvanced();
  const isContributorUser = isContributor();

  const release = process.env.REACT_APP_RELEASE
  const history = useHistory();
  return (
    <footer
      className={["container-fluid", classes.footer, "no-gutters"].join(" ")}
    >
      <Row>
        <Col md="8">
          <Nav className="mr-auto">
            <Nav.Link href={`help/${i18n.language}/General_disclaimer.html`} target="_blank">
              {t("menu.footer.general_disclaimer")}
            </Nav.Link>
            {isAdvancedUser?
              <a
                className="nav-link"
                role="button"
                onClick={() => history.push('/jurisprudence')}
              >{t("menu.footer.jurisprudence")}</a>
            :<></>}
            <NavLink
              exact
              to="/statistics"
              className="nav-link"
            >
              {t("menu.footer.statistics")}
            </NavLink>
            {isContributorUser?
              <a
                className="nav-link"
                role="button"
                onClick={() => history.push('/contributions')}
              >{t("menu.footer.contributor_portal")}</a>
            :<></>}
            <Nav.Link href={`help/${i18n.language}/About_variety_finder.html`} target="_blank">
              {t("menu.footer.about_variety_finder")}
            </Nav.Link>
            <NavLink
                className="nav-link"
                exact
                to="/requestAPIAccess"
            >
                {t("menu.footer.request_api_access")}
            </NavLink>            
          </Nav>
          <Container fluid className={classes.socialItems}>
            <a
              href="https://www.linkedin.com/company/community-plant-variety-office/"
              target="_blank"
              rel="noopener noreferrer"
              className={[classes.socialIcon, classes.linkedin].join(" ")}
            >
              <img
                alt="Linkedin"
                src={linkedin}
              ></img>
            </a>
            <a
              href="https://twitter.com/cpvotweets"
              target="_blank"
              rel="noopener noreferrer"
              className={[classes.socialIcon, classes.twitter].join(" ")}
            >
              <img
                alt="Twitter"
                src={twitter}
              ></img>
            </a>
            <a
              href="https://www.youtube.com/channel/UCUUEHok3qqYzqU_jfWb2Wew"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.socialIcon}
            >
              <img
                alt="Youtube"
                src={youtube}
              ></img>
            </a>
          </Container>
        </Col>
        <Col md="4">
          <span className="font-weight-bold">{t("cpvo")}</span>
          <br />
          <span className={classes.footerCpvoText}>
            {Parser(t("footer_address"))}
          </span>
        </Col>
      </Row>
    <Col>
    <Row className={[classes.releaseTag,"pl-4 pb-0 pt-4 justify-content-start align-content-end justify-items-end align-items-end "].join(" ") }  >
            <span> v{release}</span>
          </Row>
    </Col>
    </footer>
  );
};

export default Footer;
